<template>
  <footer id="footer-section">
    <div class="row">
      <div class="col">
        <div class="links mb-4">
          <span style="font-weight: bold; font-size: 1rem">
            <img
              style="width: 48px"
              src="@/assets/svg/Ardunic Elements-27.svg"
              alt
            />
            Links
          </span>
        </div>
        <ul style="list-style: none">
          <li class="lead"><a href="/find-us">About us</a></li>
          <li class="lead">
            <a href="/user-agreement">End user license agreement</a>
          </li>
          <li class="lead"><a href="/privacy-and-policy">Privacy policy</a></li>
          <!-- <li class="lead">We will put some Links here</li>
          <li class="lead">We will put some Links here</li>
          <li class="lead">We will put some Links here</li> -->
        </ul>
      </div>
      <div class="col">
        <div class="links mb-4">
          <span style="font-weight: bold; font-size: 1rem">
            <img
              style="width: 30px"
              src="@/assets/svg/Ardunic Elements-26.svg"
              alt
            />
            Tags
          </span>
        </div>
        <div class="tags">
          <span v-for="tag in tags" v-bind:key="tag._id" style="margin: 3px">
            <span
              :style="
                `font-size: 1.1rem; cursor: pointer; display: initial;color: white;height:20px;background:${
                  tag.color
                }`
              "
              @click="navigateTga(tag._id)"
              class="badge"
              >#{{ tag.name }}
            </span>
          </span>
          <a href="/tags" style="margin-top: 4px">... Show more</a>
        </div>
      </div>
      <div class="col">
        <div class="links mb-4">
          <span style="font-weight: bold; font-size: 1rem">
            <img
              style="width: 30px;transform: scaleX(-1)"
              src="@/assets/svg/Ardunic Elements-25.svg"
              alt
            />
            About ardunic
          </span>
        </div>
        <p>
          An Iraqi E-commerce platform for all kinds of Electronic hardware,
          components, Robotic, mechanical parts, 3D printing, DIY products,
          drones and RC, planes Industrial Plug and Play Solutions. Build to
          provide Engineers, Makers, Designers, Educators, hobbyist,
          Researchers, System Integrators and Open Source Hardware Advocates
          with the best service and everything needed to “Build Anything”.
        </p>
      </div>
      <div class="col">
        <div class="links mb-4">
          <span style="font-weight: bold; font-size: 1rem">
            <img
              style="width: 30px"
              src="@/assets/svg/Ardunic Elements-24.svg"
              alt
            />
            Find ardunic
          </span>
        </div>
        <div class="map-responsive">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3335.081566525087!2d44.41314406542777!3d33.29052901924849!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x155781ccb814da51%3A0xbe18de6a079b1460!2z2KfYsdiv2YjZhtmDINmD2LHYp9iv2Kk!5e0!3m2!1sar!2siq!4v1571418738530!5m2!1sar!2siq"
            width="100%"
            height="100%"
            frameborder="0"
            style="border: 0;border-radius: 20px;margin-top: -3px;height: 21vh;"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
    <div class="container">
      <div
        class="first-level"
        style="display: flex; justify-content: center; align-items: center"
      >
        <a target="blank" href="https://www.instagram.com/ardunic.inc"
          ><img src="https://img.icons8.com/fluent/26/000000/instagram-new.png"
        /></a>
        <a target="blank" href="https://www.facebook.com/ardunic"
          ><img src="https://img.icons8.com/fluent/26/000000/facebook-new.png"
        /></a>
        <a
          target="blank"
          href="https://www.youtube.com/channel/UCfNdRiMjBSWL8n00HX2jM-A"
          ><img src="https://img.icons8.com/fluent/26/000000/youtube-play.png"
        /></a>
        <a target="blank" href="https://www.linkedin.com/company/ardunic1"
          ><img src="https://img.icons8.com/color/26/000000/linkedin.png"
        /></a>
      </div>
      <div
        class="second-level"
        style="display: flex; justify-content: center; align-items: center"
      >
        © 2022 Ardunic Platform
      </div>
    </div>
  </footer>
</template>

<script>
import router from "../router";
import axios from "axios";
export default {
  data() {
    return {
      taggs: {
        deta: [],
      },
    };
  },
  computed: {
    tags() {
      return this.taggs.deta.map((tag) => {
        const colors = [
          "linear-gradient(90deg, #00E5FF 0%, #02B718 100%);",
          "linear-gradient(90deg, #40C012 0%, #AAF064 100%);",
          "linear-gradient(90deg, #EB3D3D 0%, #FC965C 100%);",
          "linear-gradient(90deg, #3DEBAC 0%, #5CFCF2 100%);",
          "linear-gradient(90deg, #DDB54D 0%, #E5F064 100%);",
          "linear-gradient(90deg, #0047FF 0%, #31CAFB 100%);",
        ];

        return {
          ...tag,
          color: colors[Math.floor(Math.random() * (5 - 0) + 0)],
        };
      });
    },
  },
  created() {
    this.getTags();
  },
  methods: {
    getTags() {
      axios
        .get(`https://api.ardunic.com/v1/tags?p=1&s=20`)
        .then((res) => (this.taggs.deta = res.data.data.slice(0, 20)));
    },
    navigateTga(id) {
      router.push({ path: `/tag/${id}` });
      // console.log(slug);
    },
  },
};
</script>

<style scoped>
footer {
  background: linear-gradient(to top, white, #bed7ff);
}

footer .row {
  margin: 40px 20px;
  padding-top: 40px;
}

footer .tags {
  display: flex;
  flex-wrap: wrap;
}
</style>
